import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchAboutUs = createAsyncThunk(
  "aboutUs/fetchAboutUs",
  async function (language, thunkApi) {
    try {
      if (!API_BASE_URL) {
        throw new Error("REACT_APP_API_BASE_URL is not configured");
      }

      var response = await fetch(API_BASE_URL + "/about-us", {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Accept-Language": language || "en",
        },
      });

      var contentType = response.headers.get("content-type");

      if (!contentType || contentType.indexOf("application/json") === -1) {
        throw new Error("The About Us endpoint returned an invalid response");
      }

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve About Us information"
        );
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  data: null,
  loading: false,
  error: "",
};

var aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchAboutUs.pending, function (state) {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchAboutUs.fulfilled, function (state, action) {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAboutUs.rejected, function (state, action) {
        state.loading = false;
        state.error =
          action.payload || "Unable to retrieve About Us information";
      });
  },
});

export default aboutUsSlice.reducer;